// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider-round{background-color:#dcdcdc;border:1px solid gray;height:7px}.slider-round .noUi-connect{background:#ce1141}.slider-round .noUi-handle{border-radius:15px;height:30px;right:-15px;top:-12px;width:30px}.slider-round .noUi-handle:after,.slider-round .noUi-handle:before{height:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
